const api = `${process.env.PUBLIC_URL}/api`;

export const ChatMemberApi = `${api}/chatMember.json`;
export const ChatApi = `${api}/chats.json`;